import Service from "../service";
// import AuthService from "../AuthService";

const Common = {
    getProvince() {
        return Service.get("/provinces");
    },
    getDistrict(province_id){
        return Service.get("/districts/"+province_id);
    },
    getSubDistrict(district_id){
        return Service.get('/sub_districts/'+district_id);
    },

};


export default Common;
